
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Forms/NativeSelect.html",
      function () {
        return require("private-next-pages/Forms/NativeSelect.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Forms/NativeSelect.html"])
      });
    }
  